import * as _ from 'underscore';

import * as appTheme from '../../../../_common/platform/ts/appTheme';

var template = require('!!raw-loader!pdc-widget-accordion/src/mainTheme.template.css').default;

import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { validators } from '../../../../_common/platform/ts/validators';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import { DEFAULT_CONTAINER_HEIGHT, themeFields, themeId } from '../config';

declare var Color: any;

template;

var _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: themeId,
            name: 'Widget Accordion',
            parent: 'widget',

            themeType: 'Widget Accordion',
            visibility: ['application', 'workspace', 'pdc-widget-accordion']
        }
    ]);

    appTheme.registerVars([
        {
            id: themeFields.accordionMode,
            param: new SelectField(glob, 'Accordion Mode', [], 'free', {
                values: ['free', 'singleWidget'],
                display: [
                    'Free - all Widgets can be shown at the same time',
                    'Single - only one Widget can be shown at the same time'
                ]
            }),
            section: themeId
        },
        {
            id: themeFields.widgetContainerHeight,
            param: new NumberField(
                glob,
                `Widget Container Height (set it to 0 to make it be of the widget's height)`,
                [validators.number.range(0, 1000), validators.number.integer],
                DEFAULT_CONTAINER_HEIGHT,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeId
        },
        {
            id: themeFields.tabTextColor,
            param: new ColorBoxField(
                glob,
                'Text Color',
                [],
                function (theme) {
                    return theme['on-primary'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            deps: ['on-primary']
        },
        {
            id: themeFields.tabBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Tab Background Color',
                [],
                function (theme) {
                    return theme['brand-success'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            deps: ['brand-success']
        },
        {
            id: themeFields.tabBorderRadius,
            param: new NumberField(
                glob,
                'Tab Border Radius (0-20)',
                [validators.number.range(0, 20), validators.number.integer],
                0,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeId
        },
        {
            id: themeFields.widgetBlockBorderWidth,
            param: new NumberField(
                glob,
                'Widget Block Border Width (0-20)',
                [validators.number.range(0, 20), validators.number.integer],
                1,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeId
        },
        {
            id: themeFields.widgetBlockBorderColor,
            param: new ColorBoxField(
                glob,
                'Widget Block Border Color',
                [],
                function (theme) {
                    return Color(theme['primary-bg']).lighten(20).hexString();
                },
                { hideTransparency: false }
            ),

            section: themeId,
            deps: ['primary-bg']
        },
        {
            id: themeFields.widgetBlockBorderRadius,
            param: new NumberField(
                glob,
                'Widget Block Border Radius (0-20)',
                [validators.number.range(0, 20), validators.number.integer],
                3,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeId
        }
    ]);

    appTheme.registerTemplate(template, ['pdc-widget-accordion']);

    _init.push(glob);
}
